import { createFromIconfontCN } from "@ant-design/icons";

const IconFont = createFromIconfontCN({
  scriptUrl: ["//at.alicdn.com/t/font_2465658_aqs7ojst2f.js"],
});

export default IconFont;
